import { useState } from 'react';

function useLocalStorageArray(key: string, initialValue: string[] = []) {
  const [values, setValues] = useState<string[]>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  const addValue = (value: string) => {
    // Only add if it's not already there
    if (!values.includes(value)) {
      const newValues = [...values, value];
      setValues(newValues);
      window.localStorage.setItem(key, JSON.stringify(newValues));
    }
  };

  return [values, addValue] as const;
}

export default useLocalStorageArray;
